/** Uygulama geneli tipografi — Inter */
export const FONT_FAMILY =
  '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif';

export const FONT_WEIGHT = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
};
